"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.CheckboxComponent = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = require("react");
var _checkbox = _interopRequireDefault(require("@ux/checkbox"));
require("@ux/checkbox/styles");
var _storeProvider = require("./../util/storeProvider");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
class CheckboxComponent extends _react.PureComponent {
  constructor(props) {
    super(props);
    this.handleChange = this.handleChange.bind(this);
  }
  handleChange(_, e) {
    const {
      checked
    } = e.event.target;
    const {
      handleChange,
      enumVal
    } = this.props;
    handleChange(checked ? enumVal : 'none');
  }
  render() {
    const {
      instancePath,
      content,
      enumVal,
      selectedVal,
      disabled
    } = this.props;
    const {
      store
    } = this.context;
    // intentionally not comparing type
    const checked = selectedVal == enumVal; // eslint-disable-line
    return /*#__PURE__*/React.createElement("div", null, content['feature-highlight-text'] && /*#__PURE__*/React.createElement("span", {
      className: "attr-highlight-mesg bg-warning-highlight px-1"
    }, /*#__PURE__*/React.createElement("strong", null, content['feature-highlight-text'])), /*#__PURE__*/React.createElement(_checkbox.default, {
      name: instancePath,
      "data-eid": store.getEid(enumVal, 'checkbox', checked ? 'deselect' : 'select'),
      defaultChecked: selectedVal,
      label: /*#__PURE__*/React.createElement("h5", {
        className: "mb-0"
      }, store.parseHtml(content.title)),
      onChange: this.handleChange,
      checked: checked,
      value: checked ? enumVal : false,
      disabled: disabled
    }));
  }
}
exports.CheckboxComponent = CheckboxComponent;
CheckboxComponent.propTypes = {
  disabled: _propTypes.default.bool,
  handleChange: _propTypes.default.func.isRequired,
  content: _propTypes.default.object.isRequired,
  selectedVal: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.string, _propTypes.default.number]),
  instancePath: _propTypes.default.string.isRequired,
  layoutProperties: _propTypes.default.object,
  enumVal: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.string, _propTypes.default.number])
};
var _default = exports.default = (0, _storeProvider.provideContext)(CheckboxComponent);